import {Action} from '../../../actions/shared/model/action';

export interface ActionsState {
  actions: Action[];
}

export const initialActionsState: ActionsState = {
  actions: [],
};
